import { render, staticRenderFns } from "./RouterPillNavigation.vue?vue&type=template&id=4b127000&scoped=true"
import script from "./RouterPillNavigation.vue?vue&type=script&lang=ts&setup=true"
export * from "./RouterPillNavigation.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b127000",
  null
  
)

export default component.exports